import React from 'react';
import { ChevronLeft, Lock } from 'lucide-react';
interface JobType {
  id: string;
  name: string;
  icon: string;
  isPremium: boolean;
}
interface Step4JobProps {
  selectedJob: string;
  onSelect: (job: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export const Step4Job: React.FC<Step4JobProps> = ({
  selectedJob,
  onSelect,
  onNext,
  onBack
}) => {
  const jobs: JobType[] = [{
    id: 'fitness_coach',
    name: 'Fitness Coach',
    icon: '💪',
    isPremium: false
  }, {
    id: 'hairdresser',
    name: 'Hairdresser',
    icon: '💇‍♀️',
    isPremium: false
  }, {
    id: 'spy',
    name: 'Spy',
    icon: '🕵️‍♀️',
    isPremium: true
  }, {
    id: 'flight_attendant',
    name: 'Flight Attendant',
    icon: '✈️',
    isPremium: false
  }, {
    id: 'astronaut',
    name: 'Astronaut',
    icon: '👩‍🚀',
    isPremium: true
  }, {
    id: 'teacher',
    name: 'Teacher',
    icon: '👩‍🏫',
    isPremium: false
  }, {
    id: 'lawyer',
    name: 'Lawyer',
    icon: '⚖️',
    isPremium: false
  }, {
    id: 'doctor',
    name: 'Doctor',
    icon: '👩‍⚕️',
    isPremium: false
  }, {
    id: 'esthetician',
    name: 'Esthetician',
    icon: '💆‍♀️',
    isPremium: false
  }, {
    id: 'nurse',
    name: 'Nurse',
    icon: '🏥',
    isPremium: false
  }, {
    id: 'chef',
    name: 'Chef',
    icon: '👩‍🍳',
    isPremium: false
  }, {
    id: 'model',
    name: 'Model',
    icon: '📸',
    isPremium: false
  }, {
    id: 'dancer',
    name: 'Dancer',
    icon: '💃',
    isPremium: false
  }, {
    id: 'secretary',
    name: 'Secretary',
    icon: '👩‍💼',
    isPremium: false
  }, {
    id: 'scientist',
    name: 'Scientist',
    icon: '🔬',
    isPremium: true
  }, {
    id: 'police_officer',
    name: 'Police Officer',
    icon: '👮‍♀️',
    isPremium: false
  }, {
    id: 'firefighter',
    name: 'Firefighter',
    icon: '👩‍🚒',
    isPremium: true
  }, {
    id: 'therapist',
    name: 'Therapist',
    icon: '🧠',
    isPremium: false
  }];
  const handleJobSelect = (jobId: string, isPremium: boolean) => {
    if (!isPremium) {
      onSelect(jobId);
    } else {
      // Show premium unlock modal/flow
      console.log('Premium job selected:', jobId);
      // For now, we'll just log it, but you could implement a modal here
    }
  };
  const handleContinue = () => {
    if (selectedJob) {
      onNext();
    }
  };
  return <div className="space-y-6" data-id="element-22186">
      <div className="flex items-center mb-6" data-id="element-22187">
        <button onClick={onBack} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-22188">
          <ChevronLeft size={20} className="text-gray-500" data-id="element-22189" />
        </button>
        <div className="ml-4" data-id="element-22190">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-22191">
            Choose a Job
          </h2>
          <p className="text-gray-600 dark:text-gray-400" data-id="element-22192">
            Select what your Angel does for work
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3" data-id="element-22193">
        {jobs.map(job => <div key={job.id} onClick={() => handleJobSelect(job.id, job.isPremium)} className={`p-3 rounded-lg border cursor-pointer transition-all text-center relative ${selectedJob === job.id ? 'border-pink-500 bg-pink-50 dark:bg-pink-900/20 shadow-md' : 'border-gray-200 dark:border-gray-700 hover:border-pink-300 dark:hover:border-pink-700 hover:shadow-sm'} ${job.isPremium ? 'opacity-90' : ''}`} data-id="element-22194">
            <div className="text-2xl mb-2" data-id="element-22195">{job.icon}</div>
            <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-22196">
              {job.name}
            </div>
            {job.isPremium && <div className="absolute top-1 right-1 flex items-center" data-id="element-22197">
                <Lock size={14} className="text-pink-500" data-id="element-22198" />
                <span className="text-xs text-pink-500 ml-1" data-id="element-22199">Premium</span>
              </div>}
          </div>)}
      </div>
      <div className="pt-6" data-id="element-22200">
        <div className="text-xs text-gray-500 dark:text-gray-400 mb-2 flex items-center" data-id="element-22201">
          <span className="w-4 h-4 inline-flex items-center justify-center bg-gray-200 dark:bg-gray-700 rounded-full mr-2 text-xs" data-id="element-22202">
            ?
          </span>
          This job will influence her stories, chats, and outfits
        </div>
        <button onClick={handleContinue} disabled={!selectedJob} className={`w-full py-3 rounded-lg font-medium text-white ${!selectedJob ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-pink-500 to-purple-600 hover:shadow-lg hover:shadow-pink-500/30 transition-all'}`} data-id="element-22203">
          Next: Pick a Hobby
        </button>
      </div>
    </div>;
};